/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type PayoutHistoryItemStatus = typeof PayoutHistoryItemStatus[keyof typeof PayoutHistoryItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayoutHistoryItemStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;
